import { render, staticRenderFns } from "./User.vue?vue&type=template&id=f5fd2b9a&scoped=true"
import script from "./User.vue?vue&type=script&lang=js"
export * from "./User.vue?vue&type=script&lang=js"
import style0 from "./User.vue?vue&type=style&index=0&id=f5fd2b9a&prod&lang=scss&scoped=true"
import style1 from "./User.vue?vue&type=style&index=1&id=f5fd2b9a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5fd2b9a",
  null
  
)

export default component.exports